/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featurechartstitle2Inputs */

const he_extension_featurechartstitle2 = /** @type {(inputs: Extension_Featurechartstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גרפים מפורטים`)
};

const en_extension_featurechartstitle2 = /** @type {(inputs: Extension_Featurechartstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed Charts`)
};

/**
* | output |
* | --- |
* | "Detailed Charts" |
*
* @param {Extension_Featurechartstitle2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featurechartstitle2 = /** @type {((inputs?: Extension_Featurechartstitle2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featurechartstitle2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featurechartstitle2(inputs)
	return en_extension_featurechartstitle2(inputs)
});
export { extension_featurechartstitle2 as "extension_featureChartsTitle" }